import { Link, useNavigate } from 'react-router-dom';
import useAuth from '../Auth/hook_useAuth';
import { useEffect, useState } from 'react';
import Api from '../Auth/Api';
import { decodeJWT, obterPrimeiroNome } from '../Components/jwtUtils';
import Dropdown from 'react-bootstrap/Dropdown';
import { Modal, Toast } from 'react-bootstrap';

function Header({ showSidebar, setShowSidebar }) {
    const token = JSON.parse(localStorage.getItem("user_token"))
    const nivel = decodeJWT(token).nivel;
    const navigate = useNavigate();
    const { signout } = useAuth();
    const nome_completo = localStorage.getItem("nome_completo")
    const foto = localStorage.getItem("foto")
    const [showModalRelatorios, setShowModalRelatorios] = useState(false);
    const [showToastEficacia, setShowToastEficacia] = useState(false);
    const [notificacoesEficaciaAnterior, setNotificacoesEficaciaAnterior] = useState(0);

    const [dataNotificacoes, setDataNotificacoes] = useState([]);
    const [empresaUsuario, setEmpresaUsuario] = useState(null);

    // Buscar informações da empresa do usuário (Gestor ou Aluno)
    useEffect(() => {
        if (nivel === 'Gestor' || nivel === 'Aluno') {
            async function fetchEmpresaUsuario() {
                try {
                    const usuarioLogado = decodeJWT(token);
                    const response = await Api.get(`/api/usuario/${usuarioLogado.idUsuario}`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });
                    
                    // Se o usuário tem empresa_nome, definir no estado
                    if (response.data.empresa_nome) {
                        setEmpresaUsuario({
                            id: response.data.empresa_id,
                            titulo: response.data.empresa_nome
                        });
                    }
                } catch (error) {
                    console.error('Erro ao carregar empresa do usuário:', error);
                }
            }
            fetchEmpresaUsuario();
        }
    }, [token, nivel]);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`/api/notificacoes`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                const novasNotificacoes = response.data;
                const notificacoesEficacia = novasNotificacoes.notificacoes?.filter(n => n.tipo === 'avaliacao_eficacia') || [];

                // Verificar se há novas notificações de eficácia
                if (nivel === 'Gestor' && notificacoesEficacia.length > notificacoesEficaciaAnterior && notificacoesEficaciaAnterior > 0) {
                    setShowToastEficacia(true);
                }
                setNotificacoesEficaciaAnterior(notificacoesEficacia.length);
                setDataNotificacoes(novasNotificacoes);
            } catch (error) {
                console.error(error.response?.data?.message || 'Erro ao carregar notificações')
            }
        }
        fetchData();
        // Atualizar notificações a cada 30 segundos
        const interval = setInterval(fetchData, 30000);
        return () => clearInterval(interval);
    }, [token, notificacoesEficaciaAnterior, nivel])

    return (
        <>
            <header className="header-traditional">
                <nav className="navbar navbar-expand-lg navbar-light bg-white">
                    <div className="container-fluid">
                        {/* Mobile Sidebar Toggle */}
                        <button
                            className="btn btn-link text-secondary d-lg-none me-2"
                            onClick={() => setShowSidebar(!showSidebar)}
                        >
                            <i className="bi bi-list fs-4"></i>
                        </button>

                        {/* Logo */}
                        <div className="navbar-brand d-flex align-items-center">
                            
                            {/* Exibir empresa do usuário - Desktop */}
                            {(nivel === 'Gestor' || nivel === 'Aluno') && empresaUsuario && (
                                <div className="ms-3 d-none d-md-block">
                                    <div className="d-flex align-items-center">
                                        <i className="bi bi-building text-primary me-2"></i>
                                        <div>
                                            <div className="text-primary fw-medium" style={{ fontSize: '0.9rem' }}>
                                                {empresaUsuario.titulo}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            
                            {/* Exibir empresa do usuário - Mobile */}
                            {(nivel === 'Gestor' || nivel === 'Aluno') && empresaUsuario && (
                                <div className="ms-2 d-md-none">
                                    <div className="d-flex align-items-center">
                                        <i className="bi bi-building text-primary me-1" style={{ fontSize: '0.8rem' }}></i>
                                        <span className="text-primary fw-medium" style={{ fontSize: '0.8rem' }}>
                                            {empresaUsuario.titulo.length > 15 
                                                ? empresaUsuario.titulo.substring(0, 15) + '...' 
                                                : empresaUsuario.titulo
                                            }
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Right Side Actions */}
                        <div className="d-flex align-items-center">
                            {/* Suporte */}
                            <Dropdown>
                                <Dropdown.Toggle
                                    variant=""
                                    className='btn btn-link text-secondary p-2 me-2'
                                    id="dropdown-suporte"
                                >
                                    <i className="bi bi-whatsapp fs-5 text-success"></i>
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="dropdown-menu-end support-dropdown">
                                    <Dropdown.Header>Suporte</Dropdown.Header>
                                    <Dropdown.Item onClick={() => window.open(`mailto:${process.env.REACT_APP_SUPPORT_EMAIL || 'suporte@mfjtreinamentos.com.br'}`)}>
                                        <div className="d-flex align-items-center">
                                            <i className="bi bi-envelope fs-5 me-3 text-primary"></i>
                                            <div>
                                                <div className='fw-bold'>Email</div>
                                                <small className='text-muted'>{process.env.REACT_APP_SUPPORT_EMAIL || 'suporte@mfjtreinamentos.com.br'}</small>
                                            </div>
                                        </div>
                                    </Dropdown.Item>
                                    <Dropdown.Divider />
                                    <Dropdown.Item onClick={() => window.open(`https://wa.me/${process.env.REACT_APP_WHATSAPP_NUMBER}`)}>
                                        <div className="d-flex align-items-center">
                                            <i className="bi bi-whatsapp fs-5 me-3 text-success"></i>
                                            <div>
                                                <div className='fw-bold'>WhatsApp</div>
                                                <small className='text-muted'>{process.env.REACT_APP_WHATSAPP_DISPLAY }</small>
                                            </div>
                                        </div>
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>

                            {/* Notificações */}
                            <Dropdown>
                                <Dropdown.Toggle
                                    variant=""
                                    className='btn btn-link p-2 me-2 position-relative'
                                    id="dropdown-notificacoes"
                                >
                                    <i className="bi bi-bell fs-5 text-warning"></i>
                                    {dataNotificacoes.quantidade_notificacoes > 0 && (
                                        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                            {dataNotificacoes.quantidade_notificacoes}
                                        </span>
                                    )}
                                    {/* Indicador especial para notificações de eficácia */}
                                    {dataNotificacoes.notificacoes &&
                                        dataNotificacoes.notificacoes.some(n => n.tipo === 'avaliacao_eficacia') && (
                                            <span className="position-absolute top-0 start-100 translate-middle">
                                                <i className="bi bi-stars text-warning"></i>
                                            </span>
                                        )}
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="dropdown-menu-end notification-dropdown">
                                    {dataNotificacoes.notificacoes && dataNotificacoes.notificacoes.length > 0 ? (
                                        <>
                                            <Dropdown.Header className="bg-light">
                                                <i className="bi bi-bell me-2"></i>
                                                Notificações ({dataNotificacoes.quantidade_notificacoes})
                                            </Dropdown.Header>
                                            <div className="notification-list">
                                                {dataNotificacoes.notificacoes.map((notificacao, index) => (
                                                    <div key={`${notificacao.tipo}-${notificacao.id || notificacao.certificado_id || index}`}>
                                                        <Dropdown.Item className="notification-item">
                                                            {notificacao.tipo === 'avaliacao_eficacia' ? (
                                                                <Link to={`/avaliacao-eficacia/${notificacao.certificado_id}`} className="text-decoration-none w-100">
                                                                    <div className="d-flex align-items-start">
                                                                        <i className="bi bi-stars text-warning me-3 mt-1"></i>
                                                                        <div>
                                                                            <div className="fw-bold text-primary">Avaliação de Eficácia</div>
                                                                            <div className="text-muted small mb-1">
                                                                                {notificacao.nome_aluno} - {notificacao.nome_curso}
                                                                            </div>
                                                                            <div className="text-muted small">
                                                                                Certificado emitido em {new Date(notificacao.data_emissao).toLocaleDateString('pt-BR')}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Link>
                                                            ) : (
                                                                <Link to={`/aulas/${notificacao.id_modulo}`} className="text-decoration-none w-100">
                                                                    <div className="d-flex align-items-start">
                                                                        <i className="bi bi-file-earmark-text text-primary me-3 mt-1"></i>
                                                                        <div>
                                                                            <div className="fw-bold text-primary">{notificacao.nome_avaliacao}</div>
                                                                            <div className="text-muted small">por {notificacao.nome_tutor}</div>
                                                                        </div>
                                                                    </div>
                                                                </Link>
                                                            )}
                                                        </Dropdown.Item>
                                                        {index < dataNotificacoes.notificacoes.length - 1 && (
                                                            <Dropdown.Divider />
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                            <Dropdown.Divider />
                                            <Dropdown.Item className="text-center text-muted small">
                                                <i className="bi bi-info-circle me-1"></i>
                                                Clique nas notificações para acessar
                                            </Dropdown.Item>
                                        </>
                                    ) : (
                                        <Dropdown.Item className="text-center py-4">
                                            <div className="text-muted">
                                                <i className="bi bi-bell-slash fs-4 mb-2 d-block"></i>
                                                Nenhuma nova notificação
                                            </div>
                                        </Dropdown.Item>
                                    )}
                                </Dropdown.Menu>
                            </Dropdown>

                            {/* User Menu */}
                            <Dropdown>
                                <Dropdown.Toggle
                                    variant=""
                                    className='btn btn-link d-flex align-items-center text-secondary p-2'
                                    id="dropdown-user"
                                >
                                    {foto !== 'null' ? (
                                        <img
                                            alt="foto_perfil"
                                            src={`${process.env.REACT_APP_API_URL}/fotos/${foto}`}
                                            className='rounded-circle me-2 header-profile-img'
                                        />
                                    ) : (
                                        <i className="bi bi-person-circle fs-4 me-2"></i>
                                    )}
                                    <div className="d-none d-md-flex flex-column text-start text-decoration-none">
                                        <span className="fw-normal">{obterPrimeiroNome(nome_completo)}</span>
                                        <small className="opacity-75">{nivel}</small>
                                    </div>
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="dropdown-menu-end user-dropdown">
                                    <Dropdown.Header className='d-flex align-items-center'>
                                        {foto !== 'null' ? (
                                            <img
                                                alt="foto_perfil"
                                                src={`${process.env.REACT_APP_API_URL}/fotos/${foto}`}
                                                className='rounded-circle me-2'
                                                width="40"
                                                height="40"
                                            />
                                        ) : (
                                            <i className="bi bi-person-circle fs-3 me-2"></i>
                                        )}
                                        <div>
                                            <div className="fw-bold">{nome_completo}</div>
                                            <small className="text-muted">{nivel}</small>
                                        </div>
                                    </Dropdown.Header>
                                    <Dropdown.Divider />

                                    {nivel === 'Administrador' && (
                                        <Dropdown.Item as={Link} to="/listar-topicos">
                                            <i className="bi bi-journals me-2"></i>
                                            Temas
                                        </Dropdown.Item>
                                    )}
                                    {nivel === 'Administrador' && (
                                        <Dropdown.Item as={Link} to="/ajustes">
                                            <i className="bi bi-gear-wide-connected me-2"></i>
                                            Ajustes do Sistema
                                        </Dropdown.Item>
                                    )}
                                    {(nivel === 'Administrador' || nivel === 'Gestor' || nivel === 'Moderador') && (
                                        <Dropdown.Item as={Link} to="/listar-usuarios">
                                            <i className="bi bi-people me-2"></i>
                                            Usuários
                                        </Dropdown.Item>
                                    )}

                                    <Dropdown.Item as={Link} to={nivel === 'Aluno' ? "/aluno/historico-escolar" : "/historico-escolar"}>
                                        <i className="bi bi-card-checklist me-2"></i>
                                        Histórico Escolar
                                    </Dropdown.Item>

                                    {(nivel === 'Administrador' || nivel === 'Gestor' || nivel === 'Moderador') && (
                                        <Dropdown.Item onClick={() => setShowModalRelatorios(true)}>
                                            <i className="bi bi-clipboard2-data me-2"></i>
                                            Relatórios
                                        </Dropdown.Item>
                                    )}

                                    <Dropdown.Divider />
                                    <Dropdown.Item as={Link} to="/configuracoes">
                                        <i className="bi bi-gear me-2"></i>
                                        Ajustes
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={() => [signout(), navigate("/")]} className="text-danger">
                                        <i className="bi bi-box-arrow-right me-2"></i>
                                        Sair
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </nav>
            </header>

            <Modal size="lg" show={showModalRelatorios} onHide={() => setShowModalRelatorios(false)}>
                <Modal.Header closeButton>
                    <Modal.Title className="text-center w-100">
                        Relatórios
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ background: "#f9f9f9" }}>
                    <div className="container mt-2">
                        <div className="text-center mb-4">
                            <h5>Selecione um Relatório</h5>
                            <p className="text-muted">Escolha o tipo de relatório que você deseja visualizar.</p>
                        </div>
                        <div className="list-group">
                            <Link
                                to="/relatorios/grupo"
                                onClick={() => setShowModalRelatorios(false)}
                                className="list-group-item list-group-item-action d-flex align-items-center p-3"
                            >
                                <i className="bi bi-people-fill display-4 text-success me-3"></i>
                                <div>
                                    <h5 className="mb-0">Aulas em Grupo</h5>
                                    <small className="text-muted">Visualize o progresso das aulas em grupo.</small>
                                </div>
                            </Link>
                            <Link
                                to="/relatorios/aluno"
                                onClick={() => setShowModalRelatorios(false)}
                                className="list-group-item list-group-item-action d-flex align-items-center p-3"
                            >
                                <i className="bi bi-person-lines-fill display-4 text-primary me-3"></i>
                                <div>
                                    <h5 className="mb-0">Progresso do Aluno</h5>
                                    <small className="text-muted">Acompanhe o progresso individual dos alunos.</small>
                                </div>
                            </Link>
                            <Link
                                to="/relatorios/acompanhamento"
                                onClick={() => setShowModalRelatorios(false)}
                                className="list-group-item list-group-item-action d-flex align-items-center p-3"
                            >
                                <i className="bi bi-credit-card-2-front display-4 text-info me-3"></i>
                                <div>
                                    <h5 className="mb-0">Acompanhamento de Treinamentos</h5>
                                    <small className="text-muted">Monitore o andamento e desempenho dos treinamentos.</small>
                                </div>
                            </Link>
                            {(nivel === 'Administrador' || nivel === 'Moderador') && (
                                <Link
                                    to="/relatorios/feedback"
                                    onClick={() => setShowModalRelatorios(false)}
                                    className="list-group-item list-group-item-action d-flex align-items-center p-3"
                                >
                                    <i className="bi bi-graph-up display-4 text-warning me-3"></i>
                                    <div>
                                        <h5 className="mb-0">Estatísticas de Feedback</h5>
                                        <small className="text-muted">Visualize as estatísticas das pesquisas de satisfação.</small>
                                    </div>
                                </Link>
                            )}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <button className="btn btn-outline-primary" onClick={() => setShowModalRelatorios(false)}>
                        Fechar
                    </button>
                </Modal.Footer>
            </Modal>

            {/* Toast para novas notificações de avaliação de eficácia */}
            <Toast show={showToastEficacia} onClose={() => setShowToastEficacia(false)} delay={5000} autohide style={{ position: 'fixed', left: '95%', bottom: '10px', transform: 'translateX(-95%)', zIndex: 9999, padding: 0 }}>
                <Toast.Header className="bg-warning text-dark">
                    <i className="bi bi-stars me-2"></i>
                    <strong className="me-auto">Nova Avaliação de Eficácia</strong>
                </Toast.Header>
                <Toast.Body>
                    Você tem novas avaliações de eficácia pendentes para responder.
                    Clique no sino para visualizar.
                </Toast.Body>
            </Toast>
        </>
    );
}

export default Header;
